import store from '@/store';
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  menu: false,
  column: [
    {
      label: '所属代理商',
      prop: 'businessDeptIds',
      type: 'select',
      search: false,
      searchOrder: 999,
      hide: true,
      filterable: true,
      searchMultiple: true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '所属代理商',
      prop: 'deptName',
      span: 24,
      display: false,
      hide: true,
      searchOrder: 1000,
    },
    {
      label: '库位',
      prop: 'storageLocationManagementName',
      type: 'input',
      search: true,
      searchOrder: 100,
      span: 24,
      rules: [
        {
          required: true,
          message: '请输入库位名称',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '资产类型',
      prop: 'assetType',
      type: 'radio',
      search: true,
      span: 24,
      value: 0,
      dicData: [
        {
          label: '钥匙',
          value: 0,
        },
        {
          label: '登记证书',
          value: 1,
        },
      ],
      rules: [
        {
          required: true,
          message: '请选择所属类型',
          trigger: 'change',
        },
      ],
    },
    {
      label: '原始数量',
      prop: 'originalNumber',
      display: false,
    },
    {
      label: '库存数量',
      prop: 'storageNumber',
      span: 24,
      display: false,
    },
    {
      label: 'id',
      prop: 'id',
      display: false,
      hide: true,
    },
  ],
};
